import { render, staticRenderFns } from "./affiliateWithdrawalManage.vue?vue&type=template&id=6c93c350&scoped=true"
import script from "./affiliateWithdrawalManage.vue?vue&type=script&lang=js"
export * from "./affiliateWithdrawalManage.vue?vue&type=script&lang=js"
import style0 from "./affiliateWithdrawalManage.vue?vue&type=style&index=0&id=6c93c350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c93c350",
  null
  
)

export default component.exports